<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between">
        <div class="text-right m-4">
          <h5 style="font-size: 1vw !important"> اولویت بندی مسئله/ {{$route.params.title}} </h5>
        </div>
        <div  class="d-flex" v-if="allItems.length" >
          <a   :href="`${this.download_url}/PrioritizingIssue/all/word/by/id/${id_route}`" style="margin-top: 1.3vw;"
             class="btn btn-primary btn-submit-1">خروجی Word</a>
          <a   :href="`${this.download_url}/PrioritizingIssue/all/pdf/by/id/${id_route}`"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
            PDF</a>
          <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
                :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
                @click="acceptComplete"
          >
            <div v-if="!status_loading">

              <span v-if="!status_show">  تایید وضعیت</span>
              <span v-else>عدم تایید</span>
            </div>
            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
        </div>

      </div>
      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          اطلاعاتی یافت نشد!
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="allItems.length" class="table table-striped">
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>


            <th rowspan="2"><strong>مسئله</strong></th>
            <th colspan="4"><strong>نماگر وضعیت مسئله</strong></th>
          </tr>
          <tr>
            <th>امتیاز جذابیت
              (از 1)
            </th>
            <th>امتیاز توانمندی
              (از 1)
            </th>
            <th>امتیاز نهایی مسئله
              (از 1)
            </th>
            <th>اولویت مسئله</th>


          </tr>
          <tr style="background-color: #fff;" v-for="(item, index) in allItems">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td class="d-flex">
              <input disabled :value="item.prioritizing_issue && item.prioritizing_issue.attractiveness_soccer" :id="`inputFxOne_${item.id}`" :data-number="item.id" @keyup="checkValueFxOne" type="number" max="1"
                     min="0" class="form-control"></td>

            <td>
              <div class="d-flex">
                <input disabled :value="item.prioritizing_issue && item.prioritizing_issue.ability_soccer" :id="`inputFxTwo_${item.id}`" :data-number="item.id" @keyup="checkValueFxTwo" type="number"
                       max="1" min="0" class="form-control">
              </div>
            </td>
            <td><input disabled :id="`result_${item.id}`"
                       type="text"
                       :value="item.prioritizing_issue && item.prioritizing_issue.result_soccer"
                       class="form-control"></td>
            <td><input disabled
                :value="item.prioritizing_issue && item.prioritizing_issue.order"
                :id='`order_${item.id}`' type="number" class="form-control"></td>


          </tr>


          </tbody>
        </table>
      </div>
      </div>




      <div v-show="fxOne" class="modal__error slide-top" style="width: 80vw; z-index: 9999">
        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>توانمندی</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>دسترسی به فناوری (امتیاز)</td>
            <td>0.2</td>
            <td><input v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>منابع مالی موجود (م. ریال )</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>سرمایه انسانی متخصص (نفر)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>4</td>
            <td>مکانات و زیرساخت (امتیاز)</td>
            <td>0.2</td>
            <td><input  v-model="num4" type="number" class="form-control"></td>
            </tr>

          </tbody>
        </table>
        <center>
          <button
            @click="calcOne"
             style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;"  class="btn btn-primary btn-submit-1">ذخیره

             </button>
        </center>
      </div>

      <div v-show="fxTwo" class="modal__error slide-top" style="width: 80vw; z-index: 9999">

        <table class="table table-striped">
          <tbody>
          <tr>
            <th style="width: 1vw;"><strong>ردیف</strong></th>


            <th><strong>جذابیت</strong></th>
            <th style="width: 1vw;"><strong>وزن </strong></th>
            <th  ><strong> {{title}} </strong></th>



          </tr>
          <tr>
            <td>1</td>
            <td>خلق ارزش عمومی (امتیاز)</td>
            <td>0.4</td>
            <td><input  v-model="num1" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>2</td>
            <td>صرفهجویی بودجه (م. ریال)</td>
            <td>0.3</td>
            <td><input  v-model="num2" type="number" class="form-control"></td>

          </tr>
          <tr>
            <td>3</td>
            <td>مدت زمان بازگشت سرمایه (سال)</td>
            <td>0.3</td>
            <td><input  v-model="num3" type="number" class="form-control"></td>

          </tr>

          </tbody>
        </table>
        <center>
          <button
              @click="calcTwo"
              style="margin-top: 1.3vw;margin-left: 2vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">ذخیره
          </button>
        </center>
      </div>
    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import Formula from "@/components/images/formula.vue";
import login from "@/views/auth/Login.vue";
import router from "@/router";

const toast = useToast();

export default {
  computed: {},
  components: {
    Formula,
    Sidebar,
    splash
  },
  data() {
    return {
      allItems: [],
      fxOne: false,
      fxTwo: false,
      title: '',
      id: '',
      num1: '',
      num2: '',
      num3: '',
      num4: '',
      id_route: this.$route['params']['id'],
      status_show: false,
      status_loading: false,
    }
  },
  methods: {
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }

          })
          .catch();
    },
    calcOne(){
      this.fxOne=!this.fxOne

    },
    calcTwo(){
      this.fxTwo=!this.fxTwo

    },
    fxOneMethod(title,id){
      this.fxOne=!this.fxOne
      this.title = title
      this.id = id
    },
    fxTwoMethod(title,id){
      this.fxTwo=!this.fxTwo
      this.title = title
      this.id = id

    },
    CalcNumber(num1, num2,id) {
      const one = document.getElementById(num1)
      const two = document.getElementById(num2)
        document.querySelector(`#result_${id}`).value =parseFloat(one.value) * parseFloat(two.value) < 0 ? 0 : parseFloat(one.value) * parseFloat(two.value)
    },
    checkValueFxOne(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)


    },
    checkValueFxTwo(event) {
      const inputValue = parseFloat(event.target.value);
      if (inputValue > 1) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'
        return false;

      } else if (inputValue < 0) {
        toast.error('لطفاً یک عدد معتبر بین 0 و 1 وارد کنید.');
        document.querySelector(`#${event.target.id}`).style.border = '1px solid red'

        return false;

      }
      document.querySelector(`#${event.target.id}`).style.border = '1px solid #777'
      return this.CalcNumber(`inputFxTwo_${event.target.dataset.number}`, `inputFxOne_${event.target.dataset.number}`,  event.target.dataset.number)

    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
          })
          .catch();
    },
    store(){
      let obj = []
      this.allItems.forEach((ele)=>{
        const fxOne = document.getElementById(`inputFxOne_${ele.id}`).value
        const fxTwo = document.getElementById(`inputFxTwo_${ele.id}`).value
        const result =  document.getElementById(`result_${ele.id}`).value
        const order =  document.getElementById(`order_${ele.id}`).value
        const item = {
          'problem_identifications_id': ele.id,
          'attractiveness_soccer': fxOne,
          'ability_soccer': fxTwo,
          'result_soccer': result,
          'order': order,
          'id': ele.prioritizing_issue ? ele.prioritizing_issue.id : null
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Prioritizing_Issue/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.all()
    this.checkIsMother()
  },

}
</script>
<style scoped lang="scss">
tr {
  background-color: #fff;
}
</style>